import { useState, useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';
import LauncherContainerWrapper from '../launcher/container/LauncherContainerWrapper';
// @ts-expect-error not typed
import InitialMessageBubbleContainer from '../initial-message-bubble/containers/InitialMessageBubbleContainer';
import { withBrowserSizeContext } from '../containers/withBrowserSizeContext';
import WidgetWindow from './WidgetWindow';
import { FocusScope } from '@react-aria/focus';
import { AccessibilityContext } from 'conversations-visitor-message-history/accessibility/AccessibilityContext';
import QuickReplyGroupOutsideChatContainer from './QuickReplyGroupOutsideChatContainer';
import { getUseAskMeAnythingLauncher } from '../widget-data/selectors/widgetDataSelectors';
import { handleDragHandlePositionChange } from '../post-message/handleDragHandlePositionChange';
import { shouldShowAskMeAnythingLauncher } from '../utils/shouldShowAskMeAnythingLauncher';
import WidgetWelcomePage from './WidgetWelcomePage';
import InitialPageContentWrapper from 'conversations-visitor-experience-components/visitor-widget/components/InitialPageContentWrapper';
import { CustomerAgentHoverProvider, useCustomerAgentHover } from 'conversations-visitor-experience-components/contexts/CustomerAgentHoverContext';
import { getInitialMessageForWelcomePage } from '../selectors/widgetDataSelectors/getInitialMessageForWelcomePage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ApplicationLayoutContent({
  inline,
  isOpen,
  mobile,
  onLauncherHover,
  showInitialMessageBubble,
  speechPocActive,
  toggleOpen,
  trackUserInteraction,
  widgetLocation,
  isAIChatBot,
  onSetMessageTextExternally
}) {
  const [animationsFinished, setAnimationsFinished] = useState(true);
  const [shouldRenderDialog, setShouldRenderDialog] = useState(isOpen);
  const [hasOpened, setHasOpened] = useState(false);
  const accessibilityContext = useContext(AccessibilityContext);
  const useAskMeAnythingLauncher = useSelector(getUseAskMeAnythingLauncher);
  const {
    isHoverActive: isHoveringAskMeAnythingLauncher
  } = useCustomerAgentHover();
  const showAskMeAnythingLauncher = shouldShowAskMeAnythingLauncher({
    useAskMeAnythingLauncher,
    hasOpenedWidget: hasOpened,
    mobile
  });
  useEffect(() => {
    const dragHandleState = shouldShowAskMeAnythingLauncher({
      useAskMeAnythingLauncher,
      hasOpenedWidget: hasOpened,
      mobile
    }) ? 'ask-me-anything-launcher' : 'icon-launcher';
    handleDragHandlePositionChange({
      dragHandleState
    });
  }, [useAskMeAnythingLauncher, hasOpened, mobile]);
  const openWidget = () => {
    setAnimationsFinished(false);
    trackUserInteraction();
    toggleOpen({
      isOpened: true,
      isUser: true,
      openedFrom: showAskMeAnythingLauncher ? 'ask me anything launcher' : 'icon launcher'
    });
    accessibilityContext.setShouldTrapFocus(true);
  };
  const closeWidget = () => {
    setAnimationsFinished(false);
    setHasOpened(true);
    trackUserInteraction();
    toggleOpen({
      isOpened: false,
      isUser: true
    });
  };
  const closeWidgetWelcomePage = () => {
    setAnimationsFinished(true);
    setHasOpened(true);
    trackUserInteraction();
  };
  const onOpenAnimationStarted = () => {
    setAnimationsFinished(false);
    setShouldRenderDialog(true);
    handleDragHandlePositionChange({
      dragHandleState: 'hidden'
    });
  };
  const onOpenAnimationFinished = () => {
    setAnimationsFinished(true);
    accessibilityContext.setShouldTrapFocus(true);
    handleDragHandlePositionChange({
      dragHandleState: 'widget-open'
    });
  };
  const onCloseAnimationStarted = () => {
    setAnimationsFinished(false);
    handleDragHandlePositionChange({
      dragHandleState: 'hidden'
    });
  };
  const onCloseAnimationFinished = () => {
    setAnimationsFinished(true);
    setShouldRenderDialog(false);
    accessibilityContext.setShouldTrapFocus(false);
    handleDragHandlePositionChange({
      dragHandleState: 'icon-launcher'
    });
  };
  const onLauncherAnimationStart = () => {
    handleDragHandlePositionChange({
      dragHandleState: 'hidden'
    });
  };
  const onLauncherAnimationFinished = () => {
    handleDragHandlePositionChange({
      dragHandleState: isHoveringAskMeAnythingLauncher ? 'hidden' : 'ask-me-anything-launcher'
    });
  };
  const launcherHidden = isOpen && mobile || inline || isOpen && useAskMeAnythingLauncher;
  const showContent = !useAskMeAnythingLauncher || useAskMeAnythingLauncher && animationsFinished;
  const initialMessage = useSelector(getInitialMessageForWelcomePage);
  return /*#__PURE__*/_jsx(AccessibilityContext.Consumer, {
    children: ({
      shouldTrapFocus
    }) => /*#__PURE__*/_jsxs(FocusScope, {
      contain: shouldTrapFocus,
      autoFocus: false,
      children: [/*#__PURE__*/_jsx(WidgetWindow, {
        inline: inline,
        isOpen: isOpen || inline,
        shouldRenderDialog: shouldRenderDialog,
        mobile: mobile,
        widgetLocation: widgetLocation,
        onOpenAnimationStarted: onOpenAnimationStarted,
        onCloseAnimationFinished: onCloseAnimationFinished,
        onOpenAnimationFinished: onOpenAnimationFinished,
        onCloseAnimationStarted: onCloseAnimationStarted,
        onClose: closeWidget,
        speechPocActive: speechPocActive,
        showAskMeAnythingLauncher: showAskMeAnythingLauncher,
        onSetMessageTextExternally: onSetMessageTextExternally
      }), showContent && !useAskMeAnythingLauncher && /*#__PURE__*/_jsxs(_Fragment, {
        children: [showInitialMessageBubble && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(InitialMessageBubbleContainer, {
            onClick: openWidget,
            widgetLocation: widgetLocation
          }), /*#__PURE__*/_jsx(QuickReplyGroupOutsideChatContainer, {
            widgetLocation: widgetLocation
          })]
        }), !launcherHidden && /*#__PURE__*/_jsx("span", {
          "data-test-id": "chat-widget-launcher",
          onMouseOver: onLauncherHover,
          children: /*#__PURE__*/_jsx(LauncherContainerWrapper, {
            onClose: closeWidget,
            onOpen: openWidget,
            showAskMeAnythingLauncher: showAskMeAnythingLauncher,
            useAskMeAnythingLauncher: useAskMeAnythingLauncher,
            mobile: mobile
          })
        })]
      }), showContent && useAskMeAnythingLauncher && !isOpen && /*#__PURE__*/_jsxs(InitialPageContentWrapper, {
        isMobile: mobile,
        widgetLocation: widgetLocation,
        showAskMeAnythingLauncher: showAskMeAnythingLauncher,
        shouldTrapFocus: isAIChatBot && showAskMeAnythingLauncher && !mobile,
        children: [showInitialMessageBubble && (showAskMeAnythingLauncher || mobile) && /*#__PURE__*/_jsx(WidgetWelcomePage, {
          onClose: closeWidgetWelcomePage,
          initialMessage: initialMessage,
          isMobile: mobile
        }), !launcherHidden && /*#__PURE__*/_jsx(LauncherContainerWrapper, {
          onClose: closeWidget,
          onOpen: openWidget,
          showAskMeAnythingLauncher: showAskMeAnythingLauncher,
          useAskMeAnythingLauncher: true,
          onLauncherAnimationStart: onLauncherAnimationStart,
          onLauncherAnimationFinished: onLauncherAnimationFinished,
          mobile: mobile
        })]
      })]
    })
  });
}
ApplicationLayoutContent.displayName = 'ApplicationLayoutContent';
export function ApplicationLayout(props) {
  return /*#__PURE__*/_jsx(CustomerAgentHoverProvider, {
    enableHoverTracking: !props.mobile,
    children: /*#__PURE__*/_jsx(ApplicationLayoutContent, Object.assign({}, props))
  });
}
ApplicationLayout.displayName = 'ApplicationLayout';
export default withBrowserSizeContext(ApplicationLayout);